import { createSelector } from 'reselect';

const EMPTY_RATES = {};
const EMPTY_TYPE_RATES = {};

export const getCurrenciesAllTypesRates = state =>
  state.currenciesAllTypesRates;

const getCityKey = (state, params) => params.city;
const getDateKey = (state, params) => params.date;
const getTypeKey = (state, params) => params.type;

export const makeCurrenciesAllTypesRatesByKeys = () =>
  createSelector(
    getCurrenciesAllTypesRates,
    getCityKey,
    getDateKey,
    (rates, city, date) => rates?.[city]?.[date] || EMPTY_RATES
  );

export const makeCurrenciesAllTypesRatesIsFetching = () => {
  const getCurrenciesAllTypesRatesByKeys = makeCurrenciesAllTypesRatesByKeys();

  return createSelector(getCurrenciesAllTypesRatesByKeys, rates => {
    return rates?.isFetching || false;
  });
};

export const makeCurrenciesAllTypesRatesIsInitialized = () => {
  const getCurrenciesAllTypesRatesByKeys = makeCurrenciesAllTypesRatesByKeys();

  return createSelector(
    getCurrenciesAllTypesRatesByKeys,
    rates => rates?.isInitialized || false
  );
};

export const makeCurrenciesTypeRatesItems = () => {
  const getCurrenciesAllTypesRatesByKeys = makeCurrenciesAllTypesRatesByKeys();

  return createSelector(
    getCurrenciesAllTypesRatesByKeys,
    getTypeKey,
    (rates, type) => rates?.entities?.[type] || EMPTY_TYPE_RATES
  );
};
